<script>
import { Helper } from '@/mixin/helper'
import RestEditableTableV2 from '@/components/RestEditableTableV2'
import * as manufacturerApi from '@/services/rest-api-sms/lib/vehicle/vehicle-manufacturer'
import i18n from '@/i18n'

export default {
  components: {
    RestEditableTableV2,
  },
  mixins: [Helper],
  data() {
    return {
      isTableDataAvailable: true,
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    fields() {
      return [
        {
          key: 'manufacturer',
          label: i18n.t('master.list.fleetType.manufacturer'),
          placeholder: i18n.t('master.list.fleetType.manufacturer'),
          isEditable: true,
          isSortable: true,
          validation: [['required']],
          class: 'ps-4',
        },
      ]
    },

    apiClient() {
      return {
        get: manufacturerApi.get,
        store: manufacturerApi.store,
        delete: manufacturerApi.deleteMany
      }
    },
  },
  methods: {
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    isContains(search, name) {
      const searchContains = RegExp(search ?? '', 'gi').exec(name ?? '')
      return searchContains != null && searchContains.length > 0
    },
    async handleChange() {
      const manufacturerRef = this.$refs.manufacturerRef.$refs
      await this.$nextTick()
      this.fields.forEach(field => {
        if (!field.isEditable) return
        manufacturerRef[`${field.key}-ref`].$el.addEventListener('keydown', Helper.methods.preventTabKey)
      })
    },
  },
}
</script>

<template>
  <div>
    <div class="card">
      <div class="card-body">
        <RestEditableTableV2
          ref="manufacturerRef"
          v-show="isTableDataAvailable"
          searchable
          :fields="fields"
          :apiClient="apiClient"
          :bulkDeleteApi="true"
          @available-change="handleDataAvailable"
          trackBy="manufacturer"
          :idIsString="true"
          @changeData="handleChange"
        />
      </div>
    </div>
  </div>
</template>
